<template>
  <v-card
    class="vertical-card pa-6 h-100"
    elevation="3"
    :style="{ borderTop: '6px solid ' + color }"
  >
    <div class="d-flex align-center justify-space-between mb-4">
      <v-avatar
        size="56"
        :style="{ backgroundColor: color + '1A' }"
      >
        <v-icon size="32" :color="color">{{ icon }}</v-icon>
      </v-avatar>
      <v-chip
        small
        :color="statusChip === 'Disponible' ? 'success' : 'grey lighten-2'"
        :text-color="statusChip === 'Disponible'
          ? 'white'
          : 'grey darken-1'"
      >
        {{ statusChip }}
      </v-chip>
    </div>

    <h3 class="text-h5 greydark--text font-weight-bold mb-2">
      {{ title }}
    </h3>

    <p class="text-body-1 greylight--text mb-4">{{ subtitle }}</p>

    <v-list class="transparent mb-4 pa-0">
      <v-list-item
        v-for="(bullet, idx) in bullets"
        :key="idx"
        class="px-0 py-1"
      >
        <v-list-item-icon class="mr-2">
          <v-icon :color="color" small>mdi-check-circle</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="greydark--text text-body-2">
            {{ bullet }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-btn
      v-if="route"
      depressed
      :color="color"
      class="white--text mt-2"
      :to="route"
      rounded
      block
    >
      {{ ctaLabel }}
    </v-btn>

    <v-btn
      v-else
      outlined
      :color="color"
      class="mt-2"
      href="#contact"
      rounded
      block
    >
      {{ ctaLabel }}
    </v-btn>
  </v-card>
</template>

<script>
export default {
  name: 'VerticalCard',
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
    bullets: {
      type: Array,
      required: true,
    },
    color: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    route: {
      type: String,
      default: null,
    },
    ctaLabel: {
      type: String,
      required: true,
    },
    statusChip: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.vertical-card {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.vertical-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15) !important;
}

</style>
